<template>
  <div>
    <div class="alert alert-success" v-if="alertMessage">{{ alertMessage }}</div>

    <div align="end">
      <button class="btn btn-block-mob btn-primary ml-lg-auto mt-2" @click="downloadPointsReport">
        <div v-if="processing" class="d-flex align-items-center">
          <div class="spinner-border spinner-border-sm text-light mr-2" role="status"></div>Review ROM and ACH Report
        </div>
        <span v-if="!processing">Review ROM and ACH Report</span>
      </button>
    </div>

    <div align="end">
      <button class="btn btn-block-mob btn-primary ml-lg-auto mt-2 mb-2" @click="certModal = true">
        <div v-if="certProcessing" class="d-flex align-items-center">
          <div class="spinner-border spinner-border-sm text-light mr-2" role="status"></div>
          Issue Certificates
        </div>
        <span v-if="!certProcessing">Issue Certificates</span>
      </button>
    </div>

    <modal v-if="certModal" @close="certModal = false">
      <div slot="body">
        <div class="alert alert-warning">
          You are about to issue ACH and ROM certificates for all horses who attained the necessary points.
          Proceed with the certificates generation?
        </div>
        <div class="form-row">
          <div class="form-group col">
            <label for="secretaryName">Secretary name</label>
            <input
              type="text"
              class="form-control"
              id="secretaryName"
              :class="{ 'is-invalid': $v.secretaryName.$error }"
              v-model.trim="$v.secretaryName.$model"
              placeholder="Secretary name"
            >
            <div class="invalid-tooltip">Please include the Secretary Name.</div>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <button class="btn btn-outline-primary" @click.prevent="certModal = false">Cancel</button>
          <button class="btn btn-primary ml-2" @click.prevent="downloadCertificates">Confirm</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'
import { required } from 'vuelidate/lib/validators'
import modal from '@/components/Modal'

export default {
  name: 'AdminHorseReports',
  components: { modal },
  data() {
    return {
      processing: false,
      certProcessing: false,
      certModal: false,
      secretaryName: '',
      alertMessage: ''
    }
  },
  validations: {
    secretaryName: { required }
  },
  mounted() {
    axios.get(`${this.$api}/admin/horse-certificates-printer-name`).then((response) => {
      this.secretaryName = response.data.printerName
    })
  },
  methods: {
    downloadPointsReport() {
      this.processing = true
      axios.get(`${this.$api}/admin/horse-report-points`).then((response) => {
        this.processing = false
        const url = (window.URL || window.webkitURL).createObjectURL(
          new Blob([response.data], { type: 'data:text/csv;charset=utf-8' })
        )
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'horses_points.csv')
        document.body.appendChild(link)
        link.click()
        setTimeout(() => {
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        }, 0)
      }).catch(() => {
        this.processing = false
      })
    },
    downloadCertificates() {
      this.$v.$touch()
      if (this.$v.$invalid) return

      this.certModal = false
      this.certProcessing = true
      axios.get(`${this.$api}/admin/horse-certificates-generate`, {
        Accept: 'application/pdf',
        responseType: 'arraybuffer',
        params: { secretaryName: this.secretaryName }
      }).then((response) => {
        this.certProcessing = false
        const blob = new Blob([response.data], { type: 'application/pdf' })
        if (blob.size > 0) {
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'certificates.pdf'
          link.click()
        } else {
          this.alertMessage = 'Nothing to generate.'
        }
      }).catch(() => {
        this.certProcessing = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Horses/Listing/AdminHorseReports.vue